import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StoreContexto = createContext();

const useStore = () => useContext(StoreContexto);

function StoreProvider({ children }) {
  const [auth, setAuth] = useState({
    token: '',
    idLogin: -1,
    controleSalvo: '',
    nomeSalvo: '',
    perfilSalvo: '',
  });
  const [keepOn, setKeepOn] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('tokenCognos');
    if (!storedToken) {
      navigate('/');
    }
    const storedNome = localStorage.getItem('nomeCognos');
    const storedId = localStorage.getItem('idCognos');
    const storedControle = localStorage.getItem('controleCognos');
    const storedKeepOn = localStorage.getItem('KeepOn');
    const storedPerfil = localStorage.getItem('perfilCognos');

    if (storedToken && storedNome && storedId && storedControle && storedPerfil) {
      setAuth({
        token: storedToken,
        nomeSalvo: storedNome,
        idLogin: parseInt(storedId, 10),
        controleSalvo: storedControle,
        perfilSalvo: storedPerfil,
      });

      setKeepOn(storedKeepOn === 'local' ? true : false);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (auth.token && auth.idLogin !== -1) {
      localStorage.setItem('tokenCognos', auth.token);
      localStorage.setItem('nomeCognos', auth.nomeSalvo);
      localStorage.setItem('idCognos', auth.idLogin.toString());
      localStorage.setItem('controleCognos', auth.controleSalvo);
      localStorage.setItem('KeepOn', keepOn ? 'local' : 'session');
      localStorage.setItem('perfilCognos', auth.perfilSalvo);
    }
  }, [auth, keepOn]);

  const logout = () => {
    setAuth({
      token: '',
      idLogin: -1,
      controleSalvo: '',
      nomeSalvo: '',
      perfilSalvo: '',
    });
    localStorage.removeItem('tokenCognos');
    localStorage.removeItem('nomeCognos');
    localStorage.removeItem('idCognos');
    localStorage.removeItem('controleCognos');
    localStorage.removeItem('KeepOn');
    localStorage.removeItem('perfilCognos');
  };

  const contextValue = {
    auth,
    setAuth,
    keepOn,
    setKeepOn,
    logout,
    isInitialized
  };

  return (
    <StoreContexto.Provider value={contextValue}>
      {children}
    </StoreContexto.Provider>
  );
}

export { StoreProvider, useStore, StoreContexto };
